import { LogicalRule, parseFilterToLogicalRule } from 'utils/rules';
import { emptyLogicalRule } from 'utils/nested-conditions';

export const safeParseFilter = (
  filter: string | null | undefined
): LogicalRule => {
  if (!filter) return emptyLogicalRule;
  try {
    return parseFilterToLogicalRule(filter, undefined, true);
  } catch {
    return emptyLogicalRule;
  }
};
